/**
 * 向后端请求用户的菜单，动态生成路由
 */
import {
  constantRouterMap_P, constantRouterMap_M
} from '../../config/router.config'
import {
  generatorDynamicRouter
} from '@/router/generator-routers'
const type = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? 2 : 1
const permission = {
  state: {
    // routers: type === 1 ? constantRouterMap_P : constantRouterMap_M,
    routers: constantRouterMap_P,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      // if (type === 1) {
      state.routers = constantRouterMap_P.concat(routers)
      // }
      // if (type === 2) {
      // state.routers = constantRouterMap_M.concat(routers)
      // }

    }
  },
  actions: {
    GenerateRoutes({
      commit
    }) {
      return new Promise(resolve => {
        // const { token } = data
        generatorDynamicRouter().then(routers => {
          commit('SET_ROUTERS', routers)
          resolve(routers)
        })
      })
    }
  }
}
export default permission


// WEBPACK FOOTER //
// ./src/store/async-router.js